import styled from "styled-components";

interface ContentBoxStyleProps {
  $text?: boolean;
  $padding?: boolean;
  $align?: string;
}

export const ContentBox = styled.div<ContentBoxStyleProps>`
  position: relative;
  display: flex;
  width: 100%;
  max-width: 100vw;
  flex-direction: column;
  gap: ${(props) => (props.$text === true ? "4px" : "0")};
  padding: ${(props) => (props.$padding === true ? "0 16px" : "0")};
  align-items: ${(props) => props.$align};
  gap: 12px;
`;

export const ContentTitBox = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;

export const ContentTit = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;

  h4 {
    display: flex;
    font-size: 1.8rem;
    font-weight: 500;
    font-family: "Pretendard";
    line-height: 140%;
    align-items: center;
    gap: 4px;
  }

  p {
    color: ${(props) => props.theme.colors.black60};
    font-size: 1.4rem;
  }
`;

export const subtitle = styled.h5`
  font-size: 1.4rem;
  font-weight: 800;
  color: #d1d1d1;
`;

export const ContentTotal = styled.span`
  padding: 4px 8px;
  color: ${(props) => props.theme.colors.white100};
  font-size: 1rem;
  font-weight: 700;
  background: ${(props) => props.theme.colors.black70};
  border-radius: 4px;
`;

export const ContentLink = styled.a`
  display: flex;
  padding: 2px 4px;
  color: ${(props) => props.theme.colors.black38};
  font-size: 1.3rem;
  font-weight: 500;
  font-family: "Pretendard";
  line-height: 100%;
  border-radius: 4px;
  align-items: center;

  &:active {
    background: ${(props) => props.theme.colors.black8};
  }

  svg {
    path {
      fill: ${(props) => props.theme.colors.black38};
    }
  }
`;

export const ContentLinkDiv = styled.div`
  display: flex;
  padding: 2px 4px;
  color: ${(props) => props.theme.colors.black38};
  font-size: 1.3rem;
  font-weight: 500;
  font-family: "Pretendard";
  line-height: 100%;
  border-radius: 4px;
  align-items: center;

  &:active {
    background: ${(props) => props.theme.colors.black8};
  }

  svg {
    path {
      fill: ${(props) => props.theme.colors.black38};
    }
  }
`;

export const Content = styled.div`
  position: relative;
  width: 100%;
`;

export const WritingBox = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 16px;

  p {
    font-size: 1.2rem;
    color: ${(props) => props.theme.colors.black30};
  }
`;
